import { LeftOutlined } from '@ant-design/icons'
import { useRouter } from 'next/router'
const ApplicationLayout = ({ children }) => {
  const router = useRouter()

  const handleBack = () => {
    router.back()
  }

  return (
    <div className="bg-g500 min-h-screen">
      <header className="bg-white sticky top-0 z-50 flex items-center justify-center py-4">
        <button
          onClick={handleBack}
          className="bg-white text-g400 hover:text-g500 transition-colors absolute left-4"
          aria-label="Go back"
        >
          <LeftOutlined className="h-6 w-6" /> Back
        </button>
        <span className="text-[32px] text-g400 font-extrabold font-sfui">
          Traqqie
        </span>
      </header>
      <div className="px-4 md:px-8 lg:px-24">{children}</div>
    </div>
  )
}

export default ApplicationLayout
